// extracted by mini-css-extract-plugin
module.exports = {"vPhone":"576","vTablet":"768","vTabletLandscape":"1024","vDesktop":"1280","vBigDesktop":"1600"};